// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7056ddc3","977":"dc25ca81"}[chunkId] + ".chunk.js";
};